import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';

function formatDateTime(date: Date): string {
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  }).format(date);
}

export const SessionTimer: React.FC = () => {
  const [formattedTime, setFormattedTime] = useState<string>('--/--/---- --:--:--');
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    const updateTime = () => setFormattedTime(formatDateTime(new Date()));
    updateTime();
    const interval = setInterval(updateTime, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex items-center gap-2 text-sm text-muted-foreground">
      <Clock className="w-4 h-4 text-primary flex-shrink-0" />
      <span className="tabular-nums">{mounted ? formattedTime : '--/--/---- --:--:--'}</span>
    </div>
  );
};
